<template>
  <div class="confirm-container">
    <div class="confirm-wrap">
      <div class="title">
        {{ "출금 내역 확인" }}
      </div>
      <div class="content">
        <ul>
          <li flex fjb>
            <p class="name">
              {{ activeCoin.code == "KRW" ? "출금 금액" : "출금 수량" }}
            </p>
            <p class="detail ta-r">
              <span class="bold">{{ getWithdrawalData.amount }}</span>
              {{ activeCoin.code }}
            </p>
          </li>
          <li flex fjb>
            <p class="name">{{ "출금 수수료" }}</p>
            <p v-if="$route.query.local == 'true'">0 {{ activeCoin.code }}</p>
            <p v-else class="detail ta-r">
              {{ getWithdrawalData.fee }}
              {{ activeCoin.code }}
            </p>
          </li>
          <li>
            <p class="name">{{ "받는 주소" }}</p>
            <p class="detail ta-r fs12">
              {{ getWithdrawalData.toAddress }}
            </p>
          </li>
          <li>
            <p class="name">
              {{
                activeCoin.code == "KRW"
                  ? "총 출금 금액(수수료 포함)"
                  : "총 출금 수량(수수료 포함)"
              }}
            </p>
            <p class="detail ta-r">
              <span class="bold">{{ getWithdrawalData.finalWithdraw }}</span>
              {{ activeCoin.code }}
            </p>
          </li>
        </ul>
      </div>

      <!-- 트래블룰 검증 -->
      <div v-if="needAddressee" class="travelRuleWrap">
        <div class="noti">
          <div class="title">
            <p>받는 사람 확인</p>
            <div calss="radiobuttonWrap">
              <el-radio-group v-model="recipient" @change="changeRecipient">
                <div class="recipient-items">
                  <div
                    v-for="item in recipientItems"
                    :key="item.label"
                    class="fs14 mt10 mb10 pr20"
                  >
                    <el-radio :label="item.label">{{ item.name }}</el-radio>
                  </div>
                </div>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="confirmTravelRuleWrap">
          <div class="description">
            <p class="graycolor mb10">{{ travelRuleNoti }}</p>
            {{
              recipient === 1
                ? "※ 성명은 국문으로 입력해 주세요."
                : "※ 법인명, 대표자 성명은 국문으로 입력해 주세요."
            }}
          </div>
          <div v-if="recipient === 2" class="nameWrap">
            <div>
              <p class="mb5">법인명</p>
              <el-input
                type="text"
                v-model="corpName"
                placeholder="법인명 입력"
                style="'iME-MODE:disabled"
                name="id"
                @input="verifyCorpName(corpName)"
              />
            </div>
            <!-- <div class="sub keyColor mt4 fs12">
              <p v-if="!availableCorpName">
                {{ "* 법인명은 국문으로 입력해 주세요." }}
              </p>
            </div> -->
          </div>
          <div class="nameWrap">
            <div>
              <p class="mt10 mb5">
                {{ recipient === 1 ? "성명" : "법인 대표자 성명" }}
              </p>
              <div v-if="recipient === 1" class="inputWrap">
                <el-input
                  type="text"
                  v-model="surName"
                  placeholder="받는 사람 성 입력"
                  style="'iME-MODE:disabled"
                  name="id"
                  :disabled="confirmTravelRule"
                  @input="verifySurName(surName)"
                />
                <el-input
                  type="text"
                  v-model="givenName"
                  placeholder="받는 사람 이름 입력"
                  style="'iME-MODE:disabled"
                  name="id"
                  :disabled="confirmTravelRule"
                  @input="verifyGivenName(givenName)"
                />
              </div>
              <div v-else>
                <el-input
                  type="text"
                  v-model="corpBoseName"
                  placeholder="대표자 성명 입력"
                  style="'iME-MODE:disabled"
                  name="id"
                  :disabled="confirmTravelRule"
                  @input="verifyCorpBoseName(corpBoseName)"
                />
              </div>
            </div>
            <div v-if="recipient === 1" class="sub keyColor mt4 fs12">
              <p v-if="!availableSurName || !availableGivenName">
                * 성명은 국문으로 입력해 주세요.
              </p>
            </div>
            <div v-else class="sub keyColor mt4 fs12">
              <p v-if="!availableBoseName">* 성명은 국문으로 입력해 주세요.</p>
            </div>
          </div>

          <button
            class="checkAddress"
            :disabled="disabledCheckTravelRule"
            @click="checkTravelRule"
          >
            {{ confirmTravelRule ? "받는 사람 확인 완료" : "받는 사람 확인" }}
          </button>
        </div>
      </div>
      <!-- // 트래블룰 검증 -->

      <!-- sms, otp 인증 -->
      <div class="auth">
        <div class="w12 auth-box mt10 pt10">
          <div class="w12" v-if="!useOTP">
            <div class="">
              {{ $t("mypage.bank.휴대폰 인증") }}
            </div>
            <div class="default mt4">
              <span class="gray">{{ $t("mypage.bank.휴대폰 번호") }}</span>
              {{ phoneNumberMasking(getWithdrawalData.phone) }}
            </div>
            <button
              class="w12 black mt10 mb10 checkAddress"
              @click="sendAuthCode"
              :disabled="disabledAuthNumber"
            >
              {{ $t("mypage.bank.인증번호 발송") }}
            </button>
            <div class="default mt10">
              인증번호 {{ send ? "재발송" : "발송" }}
            </div>
            <div class="w12 input-box" style="position: relative">
              <el-input
                class="w12 mt4"
                type="text"
                maxlength="6"
                pattern="[0-9]*"
                inputmode="decimal"
                v-model="authCode"
                :placeholder="$t(`notice.content.enterVerificaiton`)"
                :disabled="disabledAuthNumber"
              />
              <div class="timer roboto">
                {{ isSendCode ? remain : "00:00" }}
              </div>
            </div>
            <div class="default mt10 fs12">
              {{ $t("mypage.bank.주의사항[0]") }}
              <br />
              {{ $t("mypage.bank.주의사항[1]") }}
            </div>
          </div>
          <div v-else class="w12">
            <div>
              {{ $t("mypage.verify.OTPVerificaiton") }}
            </div>
            <div class="w12 input-box">
              <el-input
                class="w12 mt4"
                type="text"
                maxlength="6"
                pattern="[0-9]*"
                inputmode="decimal"
                v-model="authCode"
                :placeholder="$t(`notice.content.enterVerificaiton`)"
                :disabled="disabledAuthNumber"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- // sms, otp 인증 -->

      <!-- 출금하기 버튼 -->
      <div class="w12 mt20">
        <!-- 출금하기 버튼: KRW일 때 분기 -->
        <div v-if="activeCoin.code == 'KRW'">
          <button @click="withdraw()" class="withdraw-button">
            {{ $t("withdraw.withdrawal") }}
          </button>
        </div>
        <!-- 출금하기 버튼: 가상자산일 때 분기 -->
        <div v-else>
          <button
            :disabled="disabledWithdraw"
            @click="withdraw()"
            class="withdraw-button"
          >
            {{ $t("withdraw.withdrawal") }}
          </button>
        </div>
      </div>
      <!-- // 출금하기 버튼 -->
    </div>

    <!-- 출금불가 -->
    <el-dialog
      title="출금 실패"
      :visible.sync="withdrawFailModal"
      :show-close="false"
      class="modal-type01 popup modal-small"
      center
    >
      <div class="text-center">
        <p class="text-type02" v-html="withdrawResult.msg"></p>
      </div>
      <div slot="footer" class="dialog-footer">
        <button class="cancel" @click.prevent="withdrawFailModal = false">
          {{ $t("confirm.close") }}
        </button>
      </div>
    </el-dialog>
    <!-- //출금불가 -->

    <!-- 출금완료 -->
    <el-dialog
      :title="$t(`notice.title.withdrawalRequestComplete`)"
      :visible.sync="withdrawSuccessModal"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-left">
        <p class="text-type01">{{ $t("withdraw.description") }}</p>
        <ul class="modal-list" style="list-style: none">
          <li>
            <div class="mr10">{{ $t("withdraw.출금계좌 주소") }}</div>
            <div class>{{ withdrawResult.toAddress }}</div>
          </li>
          <li class="mt10">
            <div class="mr10">
              {{ $t("withdraw.출금") }} {{ activeCoin.code }}
            </div>
            <div class>
              {{ withdrawResult.finalAmount }} {{ activeCoin.code }}
            </div>
          </li>
        </ul>
      </div>
      <div slot="footer" class="button-wrap">
        <button @click="completeWithdraw(activeCoin.code)">확인</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// component
import Moment from "moment";

import AssetHeader from "../component/asset/header";
// vuex
import { mapState, mapGetters } from "vuex";
// 라이브러리
import Api from "@/common/Api";
import Decimal from "decimal.js";
import Masking from "@/common/masking.js";

export default {
  components: {
    AssetHeader,
  },
  created() {
    setInterval(this.remainTime, 1000);

    if (!_.has(this.$route.params, "coinId")) {
      this.$router.back();
      return false;
    }
    console.log("this.$route.params", this.$route.params);
    console.log("this.$route.params.activeCoin", this.$route.params.activeCoin);
    console.log(
      "this.$route.params.needAddressee",
      this.$route.params.needAddressee
    );
    console.log("this.$route.params.toParam", this.$route.params.toParam);

    this.getWithdrawalData = this.$route.params;
    this.activeCoin = this.$route.params.activeCoin;
    this.needAddressee = this.$route.params.needAddressee;
    this.tag = this.$route.params.toParam ? this.$route.params.toParam.tag : "";
  },
  data() {
    return {
      getWithdrawalData: {},
      activeCoin: {},
      phone: "",
      authCode: "",
      authToken: "",
      expire: +Moment().add(3, "minutes"),
      isSendCode: false,
      withdrawSuccessModal: false,
      withdrawFailModal: false,
      withdrawResult: {},
      corpName: "",
      corpBoseName: "",
      surName: "",
      givenName: "",
      confirmTravelRule: false,
      verifyEngSurName: false,
      verifyEngGivenName: false,
      availableCorpName: true,
      availableSurName: false,
      availableGivenName: false,
      availableCorpBoseName: false,
      tag: "",
      verificationUuid: "",
      needAddressee: false,
      remain: "00:00",
      local: "",
      recipient: 1,
      recipientItems: [
        {
          label: 1,
          name: "개인",
        },
        {
          label: 2,
          name: "법인",
        },
      ],
      travelRuleNoti:
        "※ 특정금융정보법 제6조 제3항 및 동법 시행령 제 10조의 10에 의거하여 1백만원 이상에 상당하는 가상자산을 이전하는 경우에 ‘받는 사람의 정보’를 반드시 확인 해야 합니다.",
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters(["useOTP"]),
    disabledWithdraw() {
      if (this.authCode.length !== 6) {
        return true;
      }
    },
    disabledAuthNumber() {
      if (this.needAddressee == true) {
        if (
          this.surName == "" ||
          this.givenName == "" ||
          !this.confirmTravelRule
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    disabledCheckTravelRule() {
      if (this.recipient === 1) {
        if (
          this.surName === "" ||
          this.givenName === "" ||
          !this.availableSurName ||
          !this.availableGivenName
        ) {
          return true;
        }
        return false;
      } else {
        if (
          this.corpBoseName === "" ||
          this.corpName === "" ||
          !this.availableCorpBoseName
        ) {
          return true;
        }
        return false;
      }
    },
  },
  methods: {
    sendAuthCode() {
      Api.User.sendSMS({
        token: this.$route.params.token,
      }).then((response) => {
        this.expire = +Moment().add(3, "minutes");
        this.remainTime();
        this.isSendCode = true;
        this.authToken = _.get(response, ["body", "requestCode"]);
      });
    },
    remainTime() {
      const remain = Moment(+this.expire - +Moment());
      if (+remain > 0) {
        this.remain = remain.format("mm:ss");
      } else {
        this.remain = "00:00";
      }
    },
    async withdraw() {
      // opt 인증번호 입력하지 않았을 때
      if (this.useOTP && this.authCode.length == 0) {
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: "OTP 인증번호를 입력해 주세요",
          position: "top-left",
          color: "danger",
        });
        return false;
      }

      const setName = this.recipient === 1 ? this.surName : this.corpBoseName;

      const params = {
        coinId: this.activeCoin.id,
        amount: this.getWithdrawalData.amount,
        toAddress: this.getWithdrawalData.toAddress,
        transferType: "O",
        authType: this.useOTP ? "OTP" : "SMS",
        authValue: this.authCode,
        seToken: this.getWithdrawalData.seToken,
        local: this.$route.query.local,
        vaspId: this.getWithdrawalData.vaspId,
        verificationUuid: this.verificationUuid ? this.verificationUuid : "",
        toParam: this.tag,
        primaryIdentifier: setName.trim(),
        secondaryIdentifier: this.recipient === 1 ? this.givenName.trim() : "",
        legalPersonName: this.corpName ? this.corpName.trim() : "", // 법인회사명
      };

      if (!this.useOTP) {
        params.authToken = this.authToken;
      }

      // if (this.tag) {
      //   params.toParam = this.tag;
      // }

      const error = (e) => {
        const msg = _.get(e, "msg", "서버오류");
        const { code, message } = _.get(e, ["response", "data", "header"]);
        if (_.get(e, "code") === 4100) {
          // 블랙리스트라 그냥 전역단계에서 처리하도록 둔다
          return e;
        }
        if (_.get(e, "code") === 5100) {
          // GlobalEvent.modal({ modalName: "needVerification", show: true });
          this.needVerification = true;
          return true;
        }
        if (code === 4052) {
          this.CertificationModal.show = true;
          this.CertificationModal.num = message;
          return false;
        }
        if (code == "7100") {
          this.withdrawResult.msg = `은행전산시스템 점검으로 인하여<br><strong class="txt-blue">${message} 까지</strong><br>플라이빗에서 입금 서비스 이용이 제한됩니다.`;
          this.withdrawFailModal = true;
          return false;
        }
        this.withdrawResult = {
          ...e,
          msg,
        };
        this.withdrawFailModal = true;
      };

      if (this.activeCoin.code === "KRW") {
        params.mode = "withdraw";
        params.backCode = "280";
        params.deviceType = 200;

        try {
          const response = await Api.Transfer.transferKRW(params);

          this.withdrawResult = response.body;
          this.withdrawResult.toAddress = this.accounts.deposit.accountNumber;
          this.withdrawResult.finalAmount = Decimal(response.body.amount)
            .add(response.body.fee)
            .toNumber();
          this.withdrawSuccessModal = true;
          this.$gtm.trackEvent({
            event: "ga_withdrawal",
            label: `${this.activeCoin.code} | ${Decimal(response.body.amount)}`,
          });
        } catch (error) {
          console.log(error);
          this.$msgbox({
            message: error.msg,
            type: "default",
          });
          return;
        }
      } else {
        try {
          const response = await Api.Transfer.transferAsset(params);
          this.withdrawResult = response.body;
          this.withdrawResult.finalAmount = Decimal(response.body.amount)
            .add(response.body.fee)
            .toNumber();
          this.withdrawSuccessModal = true;
          this.$gtm.trackEvent({
            event: "ga_withdrawal",
            label: `${this.activeCoin.code} | ${Decimal(response.body.amount)}`,
          });
        } catch (error) {
          if (error.code === "ACA1004") {
            this.$msgbox({
              message:
                "받는 주소 오류" + "\n" + "받는 주소를 다시 확인해 주세요.",
              type: "default",
            });
            return;
          } else {
            this.$msgbox({
              message: error.msg,
              type: "default",
            });
            return;
          }
        }
      }
    },

    async checkTravelRule() {
      const setName = this.recipient === 1 ? this.surName : this.corpBoseName;

      const params = {
        ciCode: this.activeCoin.code,
        vaspId: this.getWithdrawalData.vaspId,
        amount: this.getWithdrawalData.amount, // 수수료 제외 금액
        accountNumber:
          this.tag == ""
            ? this.getWithdrawalData.toAddress
            : this.getWithdrawalData.toAddress + ":" + this.tag,
        primaryIdentifier: setName.trim(),
        secondaryIdentifier: this.recipient === 1 ? this.givenName.trim() : "",
        legalPersonName: this.corpName ? this.corpName.trim() : "", // 법인회사명
      };
      try {
        const res = await Api.Transfer.confirmTravelRule(params);
        this.verificationUuid = res.data.result.verificationUuid;

        this.confirmTravelRule = true;
        this.disabledAuthNumber = false;
      } catch (error) {
        this.$vs.notify({
          title: this.$t("notice.title.error"),
          text: this.nl2br(error.msg),
          position: "top-left",
          color: "danger",
        });
        return false;
      }
    },
    verifySurName(value) {
      const checkEng = /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/;
      if (value.length > 0 && checkEng.test(value)) {
        this.availableSurName = true;
      } else {
        this.availableSurName = false;
      }
    },
    verifyGivenName(value) {
      const checkEng = /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/;
      if (value.length > 0 && checkEng.test(value)) {
        this.availableGivenName = true;
      } else {
        this.availableGivenName = false;
      }
    },
    verifyCorpBoseName(value) {
      const checkEng = /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/;
      if (value.length > 0 && checkEng.test(value)) {
        this.availableCorpBoseName = true;
      } else {
        this.availableCorpBoseName = false;
      }
    },
    verifyCorpName(value) {
      // const checkEng = /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/;
      // if (value.length > 0 && checkEng.test(value)) {
      //   this.availableCorpName = true;
      // } else {
      //   this.availableCorpName = false;
      // }
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
    // 전화번호 마스킹 : 뒤 3자부터 4자
    phoneNumberMasking(_value) {
      return Masking.phoneNumberMasking(_value);
    },
    changeRecipient() {
      this.surName = "";
      this.givenName = "";
      this.corpName = "";
      this.corpBoseName = "";
      this.availableCorpName = false;
      this.availableSurName = false;
      this.availableGivenName = false;
      this.availableCorpBoseName = false;
    },
    completeWithdraw(code) {
      this.withdrawSuccessModal = false;
      this.$router.push(`/balances/log/${code}`);
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
  word-break: break-all;
}
input {
  font-size: 14px;
  padding: 5px;
}
button.withdraw-button {
  width: 100%;
  padding: 10px;
}
.confirm-wrap {
  padding: 20px 12px;
  font-size: 14px;
  .content {
    padding: 10px;
    margin-top: 10px;
    background-color: #f7f8fa;
    ul {
      list-style: none;
      li {
        margin-bottom: 10px;
        &.align {
          display: flex;
          justify-content: space-between;
        }
        &:last-of-type {
          margin-bottom: 0;
          .detail {
            font-size: 16px;
            color: #eb3246;
          }
        }
      }
    }
  }
}
.noti-wrap {
  list-style: none;
  li {
    &:before {
      width: 4px;
      height: 4px;
      border-radius: 5px;
      background-color: #222;
    }
  }
}
/* 트래블룰 검증 */
.travelRuleWrap {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid #eef0f3;
  border-bottom: 1px solid #eef0f3;
  font-size: 14px;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .radiobuttonWrap {
      .items {
        display: flex !important;
      }
    }
  }
}
.confirmTravelRuleWrap {
  .description {
    margin: 10px 0 20px;
  }
}
.checkAddress {
  width: 100%;
  padding: 10px;
  margin: 20px 0;
  font-size: 14px;
  border-radius: 3px;
  background-color: #222;
}
</style>
